/**
 * Bascule entre thème sombre et thème clair.
 *
 * Un seul bouton plutôt qu'un choix à trois entrées (clair / sombre / système) :
 * le portail est sombre par défaut, et la seule question que se pose quelqu'un
 * devant l'écran est « je veux l'autre ». Un menu déroulant pour deux valeurs
 * demanderait un clic de plus pour la même décision.
 */

import { Moon, Sun } from 'lucide-react';

import { useTheme } from '../hooks/useTheme';
import { FOCUS_RING } from './ui';

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const versClair = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggle}
      // Le libellé annonce l'effet du clic, pas l'état courant : « thème clair »
      // sur un bouton dit ce qu'il va faire, ce que l'icône seule ne dit pas.
      aria-label={versClair ? 'Passer au thème clair' : 'Passer au thème sombre'}
      title={versClair ? 'Passer au thème clair' : 'Passer au thème sombre'}
      className={`rounded-md p-2 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-100 ${FOCUS_RING}`}
    >
      {versClair ? (
        <Sun className="h-4 w-4" aria-hidden="true" />
      ) : (
        <Moon className="h-4 w-4" aria-hidden="true" />
      )}
    </button>
  );
}
